
export const prePrinting = {
  prePrintingOptions: [{ label: 'type1', value: 1, active: true },
    { label: 'type2', value: 0, active: true }],
  i18nKey: 'prePrintingT',
  zhCn: {
    prePrintingT: {
      type1: '是',
      type2: '否'
    }
  },
  en: {
    prePrintingT: {
      type1: '是',
      type2: '否'
    }
  }
}
